export default __webpack_public_path__ + "static/media/ea_ln_1.3a1820fa.png";